<template>
    <b-card class="inner-block assets-vendor">
        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex">
                    <b-input id="search_filter" type="text" :placeholder="$translate('search_filter')" v-model="filter"></b-input>
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body class="p-0">
            <b-col class="page-block"><strong> {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                    {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">

                <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
                    :current-page="currentPage" :filter="filter">
                    <template #cell(id)="row">
                        <b-button :id="'asset-vendor-view-'+row.item.id" v-if="hasPermissionView" @click="$emit('show-item', row.item.id)" class="mr-2"
                            variant="pink-button">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="float-right mt-4" v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage"
                        :next-text="$translate('next')" :prev-text="$translate('previous')" aria-controls="roleTable" pills
                        align="center"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assetVendors-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() { },

    methods: {
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)
            const title = this.$translate('delete_type')
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch('assets/deleteVendor', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'error'
                            )
                        })
                }
            })
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                { key: 'description', label: this.$translate('description') },
                { key: 'notes', label: this.$translate('notes') },
                { key: 'customer_id', label: this.$translate('vendor_code'), formatter: (value, key, item) => item.customer && item.customer.name },
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },
    },
}
</script>
<style></style>
